import { createQueryClient } from "@jkast90/kast-common/query-client";
import { OfflineError, statusOf } from "./api";

// No subscribeToAuthErrors: the app has no 401 signal of its own. A query's
// 401 clears the cache, and so does the account changing (CacheScope).
export const queryClient = createQueryClient({ statusOf });

// Offline, a read fails at once with the OfflineError the page shows instead
// of waiting paused behind "Loading…" (TanStack's default), and isn't
// retried; a write fails rather than going out whenever the network is back.
// Reads still refetch on reconnect.
const defaults = queryClient.getDefaultOptions();
const retry = defaults.queries!.retry as (failures: number, error: Error) => boolean;
queryClient.setDefaultOptions({
  ...defaults,
  queries: { ...defaults.queries, networkMode: "always", retry: (failures, error) => !(error instanceof OfflineError) && retry(failures, error) },
  mutations: { ...defaults.mutations, networkMode: "always" },
});
